<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ActiveStatusForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActiveStatusForm from '@/components/settings/stock-registers/activeStatus/ActiveStatusForm'

export default {
  name: 'ActiveStatusAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ActiveStatusForm
  }
}
</script>